export const applicationCountries = {
  fr: '🇫🇷',
  be: '🇧🇪',
  it: '🇮🇹',
  nl: '🇳🇱',
}
